const compareInitialState = {
  items:       [],
  loading:     false,
  tradeOffers: {
    entrance: [],
    interior: [],
  },
};

export default compareInitialState;